import script from "./LatestRegistered.vue?vue&type=script&setup=true&lang=js"
export * from "./LatestRegistered.vue?vue&type=script&setup=true&lang=js"

import "./LatestRegistered.vue?vue&type=style&index=0&id=1436afe8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1436afe8"]])

export default __exports__